/* BOJOURNAL — recently-viewed.js
   <recently-viewed>: the pieces this visitor looked at, newest first.
   On a product page the current piece is remembered (after the list is
   drawn, so it never lists itself). Stored only in this browser, per
   language, as title / link / image / one line — no prices, which could
   go stale. Nothing is shown until there is something to show. */
(() => {
  const B = window.Bojournal;
  if (!B || !B.Component || customElements.get('recently-viewed')) return;

  const MAX = 12;

  class RecentlyViewed extends B.Component {
    init() {
      this.key = `bojournal:recent:${document.documentElement.lang || 'x'}`;
      this.list = this.querySelector('[data-recent-list]');
      const limit = Number(this.dataset.limit) || 6;
      const current = this.readCurrent();
      const items = this.load().filter((item) => !current || item.handle !== current.handle).slice(0, limit);
      if (items.length && this.list) {
        this.list.replaceChildren(...items.map((item) => this.card(item)));
        this.hidden = false;
      }
      if (current) this.save(current);
    }

    readCurrent() {
      const node = this.querySelector('[data-recent-current]');
      if (!node) return null;
      try {
        const data = JSON.parse(node.textContent);
        return data && data.handle ? data : null;
      } catch (error) {
        return null;
      }
    }

    load() {
      try {
        const raw = window.localStorage.getItem(this.key);
        const data = raw ? JSON.parse(raw) : [];
        return Array.isArray(data) ? data.filter((item) => item && item.handle && item.url) : [];
      } catch (error) {
        return [];
      }
    }

    save(current) {
      const next = [current, ...this.load().filter((item) => item.handle !== current.handle)].slice(0, MAX);
      try {
        window.localStorage.setItem(this.key, JSON.stringify(next));
      } catch (error) {
        /* storage unavailable: the section simply stays quiet */
      }
    }

    card(item) {
      const li = document.createElement('li');
      li.className = 'recent__item';
      const link = document.createElement('a');
      link.className = 'recent__link';
      link.href = item.url;
      const media = document.createElement('span');
      media.className = `recent__media media recent__media--${item.kind || 'artwork'}`;
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.width = 400;
        img.height = 500;
        media.append(img);
      }
      const title = document.createElement('span');
      title.className = 'recent__title t-product';
      title.textContent = item.title;
      link.append(media, title);
      if (item.meta) {
        const meta = document.createElement('span');
        meta.className = 'recent__meta t-caption t-muted';
        meta.textContent = item.meta;
        link.append(meta);
      }
      li.append(link);
      return li;
    }
  }

  B.define('recently-viewed', RecentlyViewed);
})();
